import { Component, OnInit, AfterViewInit, OnDestroy, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { RestApiService } from '../../rest-api.service';
import { CookieService } from '../../cookie.service';

declare var stripe: any;
declare var elements: any;

@Component({
  selector: 'app-cart-payment',
  templateUrl: './cart-payment.component.html',
  styleUrls: ['../cart-page.component.css']
})
export class CartPaymentComponent implements OnInit {
  @Input() orderNumber: string;
  @Input() cartInfo: any;
  @Input('hash') stripe_client_secret: string;
  @Input() subtotal: string;
  @Input() shipping: string;
  @Input() tax: string;
  @Input() total: string;

  @ViewChild('cardElement', {static: true}) cardElement: ElementRef;

  private card: any;
  private cardHandler = this.onChange.bind(this);
  public error: string;
  public isClicked: boolean = false;

  constructor(private el: ElementRef, private cd: ChangeDetectorRef,
              private restApi: RestApiService, private cookieService: CookieService,
              private router: Router) { }

  ngOnInit() {
    this.scrollToMe();
  }

  ngAfterViewInit() {
    const style = {
      base: {
        fontSize: '20px',
        color: "#F2ECE2",

        '::placeholder': {
          color: "#F2ECE2",
        }
      }
    };
    this.card = elements.create('card', {style: style});
    this.card.mount(this.cardElement.nativeElement);
    this.card.addEventListener('change', this.cardHandler);
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  private onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }

  async onSubmit() {
    this.isClicked = true;
    try {
      const { token, error } = await stripe.confirmCardPayment(this.stripe_client_secret,
                                                                {
                                                                  payment_method: {
                                                                  card: this.card
                                                                }
                                                              });
      if (error) {
        console.error('Something went wrong with Stripe:', error.message);
        this.isClicked = false;
        this.error = error.message;
        return;
      }
    } catch (err) {
      console.error('Something went wrong with Stripe:', err);
      this.isClicked = false;
      this.error = 'Something went wrong processing your payment. Please contact the artist through the contact form for help.';
      return;
    }
    try {
      await this.restApi.paid(this.orderNumber);
      this.cookieService.resetNavCart();
      this.router.navigate(['/confirmation']);
    } catch(err) {
      console.error('whoops...', err);
    }
  }

  private scrollToMe() {
    this.el.nativeElement.scrollIntoView({behavior:'smooth'});
  }

}
